/* eslint-disable react/no-unescaped-entities */
/**
 *
 * TableDataNotFound
 *
 */

import React, { memo } from 'react';
import moment from 'moment';
import { Button } from '@cashfree-intl/coherent';
import PropTypes from 'prop-types';

import {
  PAYMENTS,
  INITIATED_REFUNDS,
  DISPUTES,
  SUSPICIOUS,
  ALL,
  BATCH,
  BATCH_REFUNDS,
  AUTO_REFUNDS,
  AGENT_MANAGEMENT_ALL,
  AGENT_MANAGEMENT_BATCH,
  ON_DEMAND,
  ORDERS_DESCRIPTION,
  LOGS,
  OFFERS,
  SPLIT_SCHEME,
  EASY_SPLIT_ADJUSTMENTS,
  ACTION_REQUIRED,
  ALL_DISPUTES,
  ONDEMAND,
  CHECKOUT_ANALYTICS,
  INCIDENTS,
  COLLECTION_POINT_MANAGEMENT_ALL_COLLECTION_POINTS,
} from 'utils/constants';

import { CLOSED, UNDER_REVIEW } from 'containers/Disputes/constants';
import CustomIcons from '../CustomIcons';

function TableDataNotFound(props) {
  const {
    tab,
    handleClick,
    disableCta,
    searchFilter = {},
    dateFilter = {},
    filtersApplied = false,
  } = props;
  let title = 'No results found';
  let Description = '';
  let buttonContent = '';
  let Link = '';
  const isSearchApplied = Object.keys(searchFilter).length > 0;
  if (isSearchApplied) {
    const { value } = searchFilter;
    const { range, displayText } = dateFilter;

    let text = displayText.toLowerCase();
    switch (displayText.toUpperCase()) {
      case 'LAST 7 DAYS': {
        text = `in the ${text}`;
        break;
      }
      case 'THIS MONTH': {
        text = `in ${text}`;
        break;
      }
      case 'LAST MONTH': {
        text = `in the ${text}`;
        break;
      }
      case 'CUSTOM': {
        text = `in ${moment(range[0]).format('DD MMM')}- ${moment(
          range[1],
        ).format('DD MMM')}`;
        break;
      }
      default:
        break;
    }

    title = `No results found for ${value} ${text}.`;
    Description = () => (
      <span className="fnt-16">Verify the search string and the filters.</span>
    );
  } else if (filtersApplied) {
    switch (tab) {
      case ACTION_REQUIRED: {
        title = 'No Disputes Found';
        Description = () => (
          <span>
            Oops! No disputes found with the applied filters. Please adjust the
            filters to find relevant disputes.
          </span>
        );
        break;
      }
      case CLOSED: {
        title = 'No Disputes Found';
        Description = () => (
          <span>
            Oops! No disputes found with the applied filters. Please adjust the
            filters to find relevant disputes.
          </span>
        );
        break;
      }
      case UNDER_REVIEW: {
        title = 'No Disputes Found';
        Description = () => (
          <span>
            Oops! No disputes found with the applied filters. Please adjust the
            filters to find relevant disputes.
          </span>
        );
        break;
      }
      case ALL_DISPUTES: {
        title = 'No Disputes Found';
        Description = () => (
          <span>
            Oops! No disputes found with the applied filters. Please adjust the
            filters to find relevant disputes.
          </span>
        );
        break;
      }
      default:
        break;
    }
  } else {
    switch (tab) {
      case PAYMENTS: {
        title = 'No payments found';
        Description = () => (
          <span>
            Start transacting with your customers to see the payment details
            here.
          </span>
        );
        buttonContent = 'Create Payment Link';
        Link = () => (
          <a
            href="https://www.cashfree.com/docs/payments/overview"
            target="_blank"
          >
            Read Integration docs
          </a>
        );
        break;
      }
      case ONDEMAND: {
        title = 'No On-Demand Settlement Initiated.';
        Description = () => (
          <span>
            No settlements initiated. Click{' '}
            <Button
              link
              disabled={disableCta}
              className="link-cta"
              type="button"
              onClick={handleClick}
              data-event-name="Link_SettleNow"
            >
              Settle Now
            </Button>{' '}
            to send your vendor their first on-demand settlement.
          </span>
        );
        break;
      }
      case AUTO_REFUNDS:
      case BATCH_REFUNDS:
      case INITIATED_REFUNDS: {
        title = 'No refunds found';
        break;
      }
      case DISPUTES: {
        title = 'No disputes found';
        Description = () => (
          <span>
            A transaction is marked as 'Dispute' when customers or the issuing
            bank questions validity of payment. It could be due to unauthorised
            charges, failure to deliver goods/service as promised, and so on.
          </span>
        );
        break;
      }
      case ACTION_REQUIRED: {
        title = 'No Action Required';
        Description = () => (
          <span>
            You have responded to all the disputes and don't have any pending
            actions.
          </span>
        );
        break;
      }
      case UNDER_REVIEW: {
        title = 'No Disputes Under Review';
        Description = () => (
          <span>
            You don't have any disputes that are under review. Ensure you
            respond to all the disputes from the "Action Required" section.
          </span>
        );
        break;
      }
      case CLOSED: {
        title = 'No Disputes Closed';
        Description = () => (
          <span>
            You don't have any disputes that are closed. All your disputes are
            either under review or you must respond to all the disputes from the
            "Action Required" section.
          </span>
        );
        break;
      }
      case ALL_DISPUTES: {
        title = 'No Disputes Found ';
        Description = () => (
          <span>
            We will notify you if any of your customers raise a dispute. A
            dispute occurs when your customer or the issuing bank disagrees
            against a particular transaction.
          </span>
        );
        break;
      }
      case SUSPICIOUS: {
        title = 'No suspicious transaction found';
        Description = () => (
          <span>
            <a
              href="https://knowledgebase.cashfree.com/support/solutions/articles/48001146064-high-risk-transactions-high-risk-merchants"
              target="_blank"
            >
              Click here
            </a>{' '}
            for information on suspicious transactions.
          </span>
        );
        break;
      }
      case ON_DEMAND: {
        title = 'No On-Demand Settlement Initiated.';
        Description = () => (
          <span>
            No settlements initiated. Click{' '}
            <Button
              link
              disabled={disableCta}
              className="link-cta"
              type="button"
              onClick={handleClick}
              data-event-name="Link_WithdrawNow"
            >
              Withdraw Now
            </Button>{' '}
            to receive your first on-demand settlement.
          </span>
        );
        break;
      }
      case ALL: {
        title = 'No payment links created yet';
        Description = () => (
          <span>
            Create and send payment links instantly to your customers and
            collect payments.
          </span>
        );
        buttonContent = 'Create Payment Link';
        break;
      }
      case BATCH: {
        title = 'No records found';
        Description = () => (
          <span>
            Use Batch Payment Links to create and send a large number of payment
            links to your customers in one go.
          </span>
        );
        buttonContent = 'Upload File';
        break;
      }
      case 'PRODUCT-LINKS': {
        title = 'No products added';
        Description = () => (
          <span>
            Manage your store by adding your products here and send the link to
            customers to accept payments.
          </span>
        );
        buttonContent = 'Create Product Link';
        break;
      }
      case 'REPORTS': {
        title = 'No reports found';
        Description = () => (
          <span>Select required Report Type and click Generate Report.</span>
        );
        break;
      }
      case 'EASY_SPLIT_ALL': {
        title = 'No Vendor found';
        Description = () => (
          <span>Click Add New Vendor to add your first Vendor.</span>
        );
        break;
      }
      case 'EASY_SPLIT_BATCH': {
        title = 'No Batch File found';
        Description = () => (
          <span>Click Upload File to add your first Batch File.</span>
        );
        break;
      }
      case EASY_SPLIT_ADJUSTMENTS: {
        title = 'No Adjustments Found';
        Description = () => (
          <span>
            Click{' '}
            <Button
              link
              onClick={handleClick}
              className="link-cta"
              type="button"
              data-event-name="Primary_Button_AdjustBalance"
            >
              Adjust Balance
            </Button>{' '}
            to create a new adjustment.
          </span>
        );
        break;
      }
      case 'API_KEYS': {
        title = 'No API Keys found';
        Description = () => (
          <span>Click Generate API Keys to add your first API Key.</span>
        );
        break;
      }
      case 'SERVICE_ALERTS': {
        title = 'No webhooks defined yet.';
        Description = () => (
          <span>
            Webhooks notify your application when an event happens in your
            account.
          </span>
        );
        break;
      }
      case 'WEBHOOKS': {
        title = 'No webhooks defined yet.';
        break;
      }
      case AGENT_MANAGEMENT_ALL: {
        title = 'No agents added yet';
        Description = () => <span>Add and manage Agent to use softPOS.</span>;
        buttonContent = 'Add Agent';
        break;
      }
      case COLLECTION_POINT_MANAGEMENT_ALL_COLLECTION_POINTS: {
        title = 'No Collection Points added yet.';
        Description = () => (
          <span>
            Click the Add Collection Point option to add collection points and
            start collecting payments seamlessly.
          </span>
        );

        break;
      }
      case AGENT_MANAGEMENT_BATCH: {
        title = 'No files found';
        Description = () => (
          <span>Create Upload File to create and manage agents at once.</span>
        );
        buttonContent = 'Upload File';
        break;
      }
      case 'PAYMENT_FORMS_ALL': {
        title = 'No Payment Forms Found';
        Description = () => (
          <p>
            <span>
              Click Create Payment Form to collect payment from multiple
              customers using a common payment link. The payment form helps to
              collect customer details before they make the payment.
            </span>
            <br />
            <br />
            <span>
              Share the payment form on your website, social media platforms,
              WhatsApp, or any other platform to collect the payment.
            </span>
          </p>
        );
        break;
      }
      case 'PAYMENT_BUTTONS_ALL': {
        title = 'No Payment Buttons Found';
        Description = () => (
          <p>
            <span>Click Create Payment Button to create payment button.</span>
          </p>
        );
        break;
      }
      case ORDERS_DESCRIPTION: {
        title = 'No payments initiated against this order';
        break;
      }
      case LOGS: {
        title = 'No webhooks found';
        break;
      }
      case OFFERS: {
        title = 'No Offer Found';
        Description = () => (
          <span>
            Click Create New Offer and specify the offer details to create a{' '}
            <br /> unique offer for the customer.
          </span>
        );
        break;
      }
      case 'WHITELIST_DOMAIN': {
        title = 'No Whitelisted Domains Found';
        Description = () => (
          <span>
            Click New Request and specify the Whitelisting Type and Value <br />{' '}
            to get your domain whitelisted.
          </span>
        );
        break;
      }
      case 'WHITELIST_PACKAGE': {
        title = 'No Whitelisted App Packages Found';
        Description = () => (
          <span>
            Click New Request and specify the Whitelisting Type and Value <br />{' '}
            to get your package whitelisted.
          </span>
        );
        break;
      }
      case 'INTEGRATION_USAGE': {
        title = 'No Integration Data Found';
        Description = () => (
          <span>
            Start transacting on production environment to view your Integration
            Usage Data
          </span>
        );
        break;
      }
      case SPLIT_SCHEME: {
        title = 'No split configuration created yet';
        Description = () => (
          <span>
            Click the Create Split Configuration option to create a new split
            configuration.
          </span>
        );
        break;
      }
      case CHECKOUT_ANALYTICS: {
        title = 'No GA4 Measurement Id Found';
        Description = () => (
          <span>
            Click Add and specify the Platform Type and Measurement Id <br /> to
            update your GA4 Measurement Id.
          </span>
        );
        break;
      }
      case INCIDENTS: {
        title = 'No downtimes captured yet!';
        break;
      }
      default:
        break;
    }
  }

  return (
    <div
      className={`table-data-not-found-container ${
        isSearchApplied ? 'search-applied' : ''
      }`}
    >
      <div className="not-found-content">
        {!isSearchApplied && (
          <div className="image">
            <CustomIcons componentName="BOX" />
          </div>
        )}
        <div className="title">{title}</div>
        {Description && (
          <div className="description">
            <Description />
          </div>
        )}
        {buttonContent && (
          <div className="cta">
            <Button
              secondary
              onClick={handleClick}
              data-event-name={`Form_TableDataNotFound_Button_${buttonContent}`}
            >
              {buttonContent}
            </Button>
          </div>
        )}
        {Link && (
          <div>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link />
          </div>
        )}
      </div>
    </div>
  );
}

TableDataNotFound.propTypes = {
  tab: PropTypes.string,
  handleClick: PropTypes.func,
  disableCta: PropTypes.any,
  searchFilter: PropTypes.object,
  dateFilter: PropTypes.object,
  filtersApplied: PropTypes.bool,
};

export default memo(TableDataNotFound);
